import { render, staticRenderFns } from "./SendCodeNew.vue?vue&type=template&id=3a6bfd3c&scoped=true&"
import script from "./SendCodeNew.vue?vue&type=script&lang=js&"
export * from "./SendCodeNew.vue?vue&type=script&lang=js&"
import style0 from "./SendCodeNew.vue?vue&type=style&index=0&id=3a6bfd3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6bfd3c",
  null
  
)

export default component.exports